/* export const ip = "http://192.168.19.106:7001"; */
//export const ip = 'http://124.16.0.106:9900';
//  export const ip = "http://192.3.20.10:7001"; 
//  export const ip = "http://192.168.19.134:7001"; 
 
export const ip = 'https://liuzhuan.caseeder.cn';

//console.log(process.env.NODE_ENV)



// WEBPACK FOOTER //
// ./src/config/index.js